import React from "react";
import {
  evaluatePassword,
  PASSWORD_REQUIREMENTS,
  STRENGTH_LABELS,
} from "../../../utils/passwordPolicy";
import "./styles.scss";

/**
 * Live strength meter for a password field.
 *
 * Renders nothing until something is typed, so an untouched form stays clean.
 * `username` and `email` are passed through to the policy so it can reject a
 * password built out of the account's own identity.
 */
const PasswordStrength = ({ password, username, email }) => {
  if (!password) return null;

  const { score, label, checks } = evaluatePassword(password, { username, email });
  // One segment per strength level, so even "Very weak" lights up a single bar
  // rather than looking like an empty control.
  const filled = score + 1;

  return (
    <div className="password-strength">
      <div className="password-strength__bar" aria-hidden="true">
        {STRENGTH_LABELS.map((_, segment) => (
          <span
            key={segment}
            className={`password-strength__segment ${
              segment < filled ? `password-strength__segment--level-${score}` : ""
            }`}
          />
        ))}
      </div>
      <p className={`password-strength__label password-strength__label--level-${score}`}>
        Password strength: {label}
      </p>
      <ul className="password-strength__rules">
        {PASSWORD_REQUIREMENTS.map((rule) => (
          <li
            key={rule.key}
            className={`password-strength__rule ${
              checks[rule.key] ? "password-strength__rule--met" : ""
            }`}>
            <span className="password-strength__rule-mark" aria-hidden="true">
              {checks[rule.key] ? "✓" : "✕"}
            </span>
            {rule.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrength;
